import {GoogleMap, GoogleMapProps} from "@react-google-maps/api";
import React from "react";

const GoogleMapWrapper = (props: GoogleMapProps): React.ReactElement => <GoogleMap {...props} />;

export default GoogleMapWrapper;
